import { store, mutations } from '@/store';
import { showToast } from '@/utils/toast';
import { replaceMarkdownCodeFence } from '@/utils/text';

/**
 * Build editor state for a code block the user clicked "Edit" on.
 * `block` comes from MarkdownRenderer's `edit-code` event.
 */
export function createCodeEditorState(message, block) {
  if (!message || !block) return null;
  return {
    message,
    block,
    artifact: {
      source: block.code,
      language: block.language
    }
  };
}

/**
 * Write the edited code back into the original fenced block of the chat message
 * and persist the session. Returns true when the editor can be closed.
 */
export async function applyCodeEditToMessage(state, update, t) {
  if (!state || !update || typeof update.source !== 'string') return false;
  const { message, block } = state;

  // Refuse to patch by line range if the message changed (or the session switched) since the editor opened.
  if (!store.history.includes(message) || message.content !== block.source) {
    showToast(t('codeEditor.sourceChanged'), 'error');
    return false;
  }

  const nextContent = replaceMarkdownCodeFence(message.content, block.map, block.markup, update.source);
  if (nextContent === null) {
    showToast(t('codeEditor.applyFailed'), 'error');
    return false;
  }

  message.content = nextContent;
  try {
    await mutations.finalizeLastMessage();
  } catch (error) {
    console.error('Failed to persist code block edit:', error);
  }
  showToast(t('codeEditor.applied'), 'success');
  return true;
}
